import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import styled from 'styled-components';
import { responsiveThemeStyle } from "../../theme/responsive";
export var Stack = React.forwardRef(function (_ref, ref) {
  var alignX = _ref.alignX,
      _ref$gap = _ref.gap,
      gap = _ref$gap === void 0 ? 0 : _ref$gap,
      children = _ref.children,
      other = _objectWithoutProperties(_ref, ["alignX", "gap", "children"]);

  return /*#__PURE__*/React.createElement(StyledStack, _extends({
    ref: ref,
    alignX: alignX,
    gap: gap
  }, other), React.Children.map(children, function (child, i) {
    return React.isValidElement(child) ? /*#__PURE__*/React.createElement(StackItem, {
      key: i,
      as: other.as === 'ul' ? 'li' : undefined,
      "data-testid": other['data-testid'] ? "".concat(other['data-testid'], "--item-").concat(i) : undefined
    }, child) : child;
  }));
});
var responsiveSpace = responsiveThemeStyle('paddingBottom', 'spaces');
export var StackItem = styled.div.withConfig({
  displayName: "Stack__StackItem",
  componentId: "vapor__sc-1ntcct4-0"
})([""]);
var StyledStack = styled.div.withConfig({
  displayName: "Stack__StyledStack",
  componentId: "vapor__sc-1ntcct4-1"
})(["margin:0;padding:0;border:0;display:block;li{list-style-type:none;}& > ", "{", "}& > ", ":not(:last-child){", ";}"], StackItem, function (p) {
  return p.alignX && "\n      display: flex;\n      flex-direction: column;\n      align-items: ".concat(alignments[p.alignX], ";\n    ");
}, StackItem, function (p) {
  return responsiveSpace(p.gap);
});
var alignments = {
  start: 'flex-start',
  end: 'flex-end',
  center: 'center',
  auto: 'auto'
};
export var testExports = {
  StackItem: StackItem
};